import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import { HubConnectionState } from '@microsoft/signalr';
import { constants } from '../../constants';
import { appConfig } from '../../app-config';
import { useAppDispatch } from '../../effects/useAppDispatch';
import { notificationActions } from '../../actions/notification.actions';
import IconSVG from '../../styles/svg-icons';

export function ConnectionStatusToast({ disabled }) {
    const { connectionStatus } = useSelector(state => state.notification);
    const [visible, setVisible] = useState(true);
    const enabledByQaFlag = useQaConnectionStripe();

    useEffect(() => {
        if (connectionStatus === HubConnectionState.Connected) {
            setTimeout(() => {
                if (connectionStatus === HubConnectionState.Connected) {
                    setVisible(false);
                }
            }, constants.notificationDisplayTimeout);
        } else {
            setVisible(true);
        }
    }, [connectionStatus]);

    if (!visible || (disabled && !enabledByQaFlag)) {
        return null;
    }

    const refreshPage = () => window.location.reload();

    if (connectionStatus === HubConnectionState.Reconnecting) {
        return (
            <div className="connection-toast connection-toast-connecting">
                <div className="connection-toast-icon">
                    <IconSVG name="warning" width={16} height={16} />
                </div>
                <div className="connection-toast-message">Looks like there is a problem with the connection. Connecting...</div>
            </div>
        )
    }

    if (connectionStatus === HubConnectionState.Connected) {
        return (
            <div className="connection-toast connection-toast-connected">
                <div className="connection-toast-message">Connected!</div>
            </div>
        )
    }

    if (connectionStatus === HubConnectionState.Disconnected) {
        return (
            <div className="connection-toast connection-toast-disconnected">
                <div className="connection-toast-icon">
                    <IconSVG name="warning" width={16} height={16} />
                </div>
                <div className="connection-toast-message">
                    Looks like we're having trouble retrieving some information.
                    Please <span onClick={refreshPage}>refresh the page</span>.
                </div>
            </div>
        )
    }

    return null;
}

function useQaConnectionStripe() {
    const dispatch = useAppDispatch();
    const connectionStripeEnabled = useSelector(state => state.notification.connectionStripeEnabled);

    useEffect(() => {
        if (!appConfig.connectionStripeEnabled) {
            return;
        }

        const { connectionStripe } = queryString.parse(window.location.search);

        if (connectionStripe != null) {
            dispatch(notificationActions.setConnectionStripeEnabled(connectionStripe === 'true'));
        }
    }, [dispatch]);

    return appConfig.connectionStripeEnabled && connectionStripeEnabled;
}
